import * as React from "react";

function SvgResponsys(props, ref) {
  return (
    <svg
      id="Responsys_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 256.8 50.7"
      xmlSpace="preserve"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <style>
        {".Responsys_svg__st0{fill:#fd4036}.Responsys_svg__st1{fill:#fff}"}
      </style>
      <g id="Responsys_svg__Page-1">
        <g id="Responsys_svg__Artbox">
          <g id="Responsys_svg__responsys_logo" transform="translate(40 126)">
            <path
              id="Responsys_svg__Shape"
              className="Responsys_svg__st0"
              d="M-30.1-116.1h7.7v4.8c1.3-1.5 2.4-3.5 4.3-4.4 1.4-.6 3-.7 4.5-.9 0 2.7 0 5.4.1 8.1-3.2.3-6.7 1.4-7.9 4.6-1.8 5-.8 10.5-1.1 15.7h-7.7c0-9.3 0-18.6.1-27.9z"
            />
            <path
              className="Responsys_svg__st0"
              d="M-6.8-114c5.3-3.6 13.3-3 17.5 2 3.2 3.5 3.6 8.4 3.5 12.9-6.6 0-13.2-.2-19.7.2C-4.1-97-3-94.4-.4-94c3.2.9 6.4-.5 8.9-2.5 1.5 1.3 2.9 2.7 4.4 4-2.1 1.7-4.1 3.7-6.8 4.4-5.4 1.6-12.1.3-15.8-4.3-5.3-6.3-4-17 2.9-21.6z"
            />
            <path
              className="Responsys_svg__st1"
              d="M-5.5-103.9c1-2.4 2.1-5.3 5.1-5.6 3.7-.8 6.3 2.4 7.2 5.7-4.1.1-8.2 0-12.3-.1z"
            />
            <path
              className="Responsys_svg__st0"
              d="M50.2-112.3c3.7-4.3 10.2-5.3 14.9-2.3 6.5 4.1 7.8 13.4 4.7 20-2.2 5.1-8.1 8-13.4 6.8-2.5-.4-4.3-2.1-6.2-3.6v11.6h-7.9c.1-12.1.1-24.1 0-36.2h7.9v3.7z"
            />
            <path
              className="Responsys_svg__st1"
              d="M54.2-109.2c4.6-2.5 10.1 2.4 9.4 7.3.4 4.5-4.3 8.8-8.7 7.1-6-1.9-6.4-11.9-.7-14.4z"
            />
            <path
              className="Responsys_svg__st0"
              d="M84.3-115.8c6.1-1.6 13.1.6 16.7 5.9 4 5.9 2.8 14.8-2.9 19.2-7 5.7-18.9 3.8-23.1-4.5-4.4-7.9.6-18.7 9.3-20.6z"
            />
            <path
              className="Responsys_svg__st1"
              d="M85.7-109.4c5.1-2.2 10.8 2.8 9.9 8.1-.1 4.7-5.4 8.1-9.6 6.3-6.3-2-6.5-12.2-.3-14.4z"
            />
            <path
              id="Responsys_svg__Shape_4_"
              className="Responsys_svg__st0"
              d="M113.3-112.2c2.1-2.1 4.6-4.3 7.8-4 4.8-.6 9.1 3.5 9.4 8.3.4 6.6.1 13.2.1 19.9-2.6 0-5.2 0-7.8.1-.1-5.9.3-11.8-.2-17.7-.5-3.7-6-4.6-8.1-1.9-1.3 1.6-1.2 3.9-1.3 5.8 0 4.6 0 9.1.1 13.7h-7.9c0-9.3-.1-18.6 0-27.9h7.8c0 1.2.1 2.4.1 3.7z"
            />
            <path
              id="Responsys_svg__Shape_5_"
              className="Responsys_svg__st0"
              d="M20.5-114.1c6.1-3.6 13.9-1.8 19.3 2.2-1.6 1.4-3.1 3-4.8 4.2-2.1-.7-3.9-2.1-6.1-2.3-1.5 0-3 .3-4.4.5v2.7c4.5 1.4 9.5 1.5 13.4 4.3 3.9 3.2 3 10-1.2 12.5-6.8 4.5-16.3 2.9-22.2-2.4 1.5-1.5 3-3.2 4.8-4.4 1.7.6 3 1.9 4.7 2.5 2.5 1.2 5.5 1 7.8-.4.2-1.1.9-2.6-.7-2.8-4.2-1.6-9.2-1.2-12.7-4.3-3.5-3.6-2.1-10 2.1-12.3z"
            />
            <path
              id="Responsys_svg__Shape_6_"
              className="Responsys_svg__st0"
              d="M138.4-113.8c5.8-3.8 13.4-2.1 19 1.3 0 .3.1.9.1 1.3-1.4 1.2-2.6 2.5-4.1 3.5-2.6-.6-5-2.7-7.8-2.2-1.6 0-3.7 1-2.9 2.9 4.1 2.1 9.1 1.6 12.9 4.3 3.3 2.2 3.8 7.1 1.8 10.3-1.4 2.2-3.8 3.6-6.3 4.4-6.4 1.8-13.6.2-18.3-4.5 1.6-1.4 3.1-3 4.9-4.2 3.3 1.9 7 4.5 11 2.9 1.7-.2 1.5-2.1 1.9-3.3-4.4-1.5-9.4-1.4-13.4-4.1-3.9-3.4-3-10.1 1.2-12.6z"
            />
            <path
              id="Responsys_svg__Shape_7_"
              className="Responsys_svg__st0"
              d="M158.3-115.9h8.4c2 6.3 4.1 12.5 6.2 18.8 2.3-6.2 4-12.6 6.2-18.8 2.7 0 5.3 0 8 .1-3.4 9.4-7 18.8-10.5 28.2-1.3 3.3-3 7.1-6.8 7.9-3.3 1.6-6.5-.4-9.5-1.7.8-1.8 1.7-3.5 2.5-5.2 2 .2 4.1.3 6.1.3-.3-1.9-.7-3.8-1.5-5.6-3-8.1-6.1-16.1-9.1-24z"
            />
            <path
              id="Responsys_svg__Shape_8_"
              className="Responsys_svg__st0"
              d="M187.1-109.8c1-3.1 4.1-5.1 7.1-5.8 5.3-1.2 11.1.2 15.5 3.5-1.3 1.7-2.7 3.3-4.5 4.4-3.3-1.4-7.1-3.7-10.6-1.3 0 .5-.1 1.4-.2 1.8 4.1 2.2 9.1 1.7 13 4.4 2.6 1.7 3.6 5.3 2.7 8.3-.9 3.3-4 5.5-7.2 6.4-6.4 1.9-13.5.1-18.4-4.5 1.6-1.4 3.1-3 4.9-4.2 3.5 1.9 7.5 4.7 11.6 2.6 1.6-.3 1.1-2 1.1-3.1-3.9-1.6-8.4-1.4-12.1-3.5-3.2-1.7-4.2-5.9-2.9-9z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgResponsys);
